import { CART_COPY } from './cartCopy';

const ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
/** Names and messages are customer input: always escape before they reach innerHTML. */
export const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ESCAPES[char]);

/**
 * Detail parts as display lines: an `ownLine` part gets a line to itself; the others share one, " · " joined.
 * @param {import('./buildPackagingBlock').DetailPart[]} details
 * @returns {import('./buildPackagingBlock').DetailPart[][]}
 */
const detailLines = (details) =>
  details.reduce((lines, part) => {
    const last = lines[lines.length - 1];
    if (last && !part.ownLine && !last[0].ownLine) last.push(part);
    else lines.push([part]);
    return lines;
  }, []);

/**
 * HTML for one packaging block (Figma frame 7 collapsed, frame 8 expanded). Collapsed by default.
 * @param {import('./buildPackagingBlock').PackagingBlock} block
 * @param {{ id: string, money: (amount: number, options?: { trimWhole?: boolean }) => string }} options
 * @returns {string}
 */
export function renderPackagingBlock(block, { id, money }) {
  const detail = (part) =>
    part.surcharge == null ? escapeHtml(part.text) : `${escapeHtml(part.text)} (+${escapeHtml(money(part.surcharge, { trimWhole: true }))})`;

  const items = (panel) =>
    panel.items
      .map(
        (item) => `
        <div class="packaging-block__item">
          <div class="packaging-block__item-row">
            <span class="packaging-block__name">${escapeHtml(item.name)}</span>
            <span class="packaging-block__price">${escapeHtml(money(item.price))}</span>
          </div>${detailLines(item.details)
            .map(
              (parts) => `
          <p class="packaging-block__detail">${parts.map(detail).join(' · ')}</p>`
            )
            .join('')}
        </div>`
      )
      .join('');

  const panels = block.panels
    .map(
      (panel) => `
      <div class="packaging-block__panel" data-category="${escapeHtml(panel.category)}">
        <p class="packaging-block__category">${escapeHtml(panel.label)}</p>${items(panel)}
      </div>`
    )
    .join('');

  return `
    <div class="packaging-block__card">
      <div class="packaging-block__header">
        <p class="packaging-block__title">${escapeHtml(CART_COPY.title)} (${block.count}) - ${escapeHtml(money(block.subtotal))}<span class="visually-hidden">: ${escapeHtml(block.categoryLabel)}. ${escapeHtml(block.summary)}</span></p>
        <button type="button" class="packaging-block__toggle" aria-expanded="false" aria-controls="${escapeHtml(id)}">${escapeHtml(CART_COPY.viewSelection)}</button>
      </div>
      <div class="packaging-block__panels" id="${escapeHtml(id)}" hidden>${panels}
        <div class="packaging-block__actions">
          <button type="button" class="packaging-block__remove">${escapeHtml(CART_COPY.removeAll)}</button>
        </div>
      </div>
    </div>`;
}
